export default class NormalizeUtils {
    static normalize(data) {
        data = NormalizeUtils.trim(data);
        return data;
    }
    static trim(data) {
        if (typeof (data) === 'string') {
            return data.trim();
        }
        const stack = [];
        if (typeof (data) === 'object') {
            stack.push(data);
        }
        while (stack.length > 0) {
            const item = stack.pop();
            // include inherited properties
            for (const key in item) {
                if (typeof (item[key]) === 'object') {
                    stack.push(item[key]);
                }
                else if (typeof (item[key]) === 'string') {
                    item[key] = item[key].trim();
                }
            }
        }
        return data;
    }
}
//# sourceMappingURL=NormalizeUtils.js.map